module.exports = __webpack_public_path__ + "img/p2.fec846b7.png";